import React, {useContext, useEffect, useState} from "react";
import UserProfileContext from "../../../../../services/UserProfileContext";
import {Button, Input, message, Modal, Space, Table} from "antd";
import {apiClient} from "../../../../../services/ApiClient";
import {DeleteOutlined, EditFilled} from "@ant-design/icons";
import UpdateButton from "../../../../buttons/UpdateButton";
import TaxiCarGroupEditDialog from "./TaxiCarGroupEditDialog";

const {Search} = Input;

export default function TaxiCarGroupsSettingsTab({active}) {
  const userProfile = useContext(UserProfileContext);

  let [loading, setLoading] = useState(false);
  let [editedRecord, setEditedRecord] = useState(null);
  let [selected, setSelected] = useState([]);
  let [records, setRecords] = useState([]);
  let [update, setUpdate] = useState(0);
  let [search, setSearch] = useState("");

  const cols = [
    {
      title: "",
      align: "center",
      width: 30,
    },
    Table.SELECTION_COLUMN,
    {
      title: "",
      width: 50,
      render: (text, record, index) => {
        return (
          <Space direction={"horizontal"}>
            <Button type="link" onClick={() => { setEditedRecord(record) }}><EditFilled/></Button>
          </Space>
        )
      }
    },
    {
      title: 'Наименование',
      dataIndex: 'title',
    },
    {
      title: 'Процент',
      dataIndex: 'payment_percentage',
    },
    {
      title: "",
      align: "center",
      width: 20,
    }
  ];

  const onSelectChange = selectedRowKeys => {
    setSelected(selectedRowKeys);
  };

  useEffect(() => {
    if(active) {
      setLoading(true);
      apiClient.getVehicleGroups({
        order: "title",
        search: search,
      })
        .then(res => {
          setRecords(res.records);
        })
        .catch(err => message.error(err))
        .finally(() => { setLoading(false); });
    } else {
      setRecords([]);
    }
  }, [active, search, update]);

  const onDeleteSelected = () => {
    Modal.confirm({
      title:  "Удаление",
      content: "Вы уверены, что хотите удалить записи?",
      icon: <DeleteOutlined/>,
      visible: true,
      onOk() {
        apiClient.removeVehicleGroups(selected)
          .then(res => {
            message.success("Записи удалены");
            setSelected([]);
            setUpdate(u => u + 1);
          })
          .catch(err => message.error(err));
      },
    });
  };

  const onUpdate = (recordId, params) => {
    setLoading(true);
    apiClient.updateVehicleGroup(recordId, params)
      .then(res => {
        message.success("Запись обновлена");
        setUpdate(u => u + 1);
      })
      .catch(err => {
        message.error(err);
        setLoading(false);
      })

  };

  const onAdd = (params) => {
    setLoading(true);
    apiClient.createVehicleGroup(params)
      .then(res => {
        message.success("Запись добавлена");
        setUpdate(u => u + 1);
      })
      .catch(err => {
        message.error(err);
        setLoading(false);
      })

  };

  return (
    <>
      <div style={{width: '100%'}}>
        <div style={{width: '60%', float: 'left'}} >
          <Space direction={"horizontal"} wrap>
            <Search
              allowClear
              placeholder="Поиск"
              onSearch={(value) => setSearch(value)}
              style={{width: 400}}
              enterButton
            />
          </Space>
        </div>
        <div style={{width: '40%', float: 'right'}} >
          <Space style={{float: "right", marginBottom: 16}} direction="horizontal">
            {
              selected.length > 0 && (<span>{`Выбрано записей: ${selected.length}`}</span>)
            }
            <UpdateButton loading={loading} onClick={() => { setUpdate(u => u + 1) }}/>
            <Button type="primary" loading={loading} onClick={() => { setEditedRecord({id: 0}) }}>
              Добавить
            </Button>
            {
              userProfile.is_superuser && (
                <Button type="danger" loading={loading} onClick={onDeleteSelected} disabled={selected.length === 0}>
                  Удалить
                </Button>
              )
            }
          </Space>
        </div>
      </div>
      <Table
        pagination={
          {
            position: 'topRight',
            defaultPageSize: 50,
            pageSizeOptions: [25, 50, 75]
          }
        }
        rowSelection={{
          selectedRowKeys: selected,
          onChange: onSelectChange,
        }}
        size={'small'}
        columns={cols}
        scroll={{y: 600}}
        dataSource={records}
        rowKey="id"
      />

      {
        editedRecord !== null && (
          <TaxiCarGroupEditDialog
            visible={true}
            taxiCarGroup={editedRecord}
            onOk={(p) => {
              if(editedRecord?.id > 0) {
                onUpdate(editedRecord?.id, p);
              } else {
                onAdd(p);
              }
              setEditedRecord(null);
            }}
            onCancel={() => { setEditedRecord(null) }}
            title={"Группа ТС"}
          />
        )
      }
    </>
  )
}